var _dec, _class, _descriptor, _dec2, _class2, _descriptor2, _dec3, _dec4, _dec5, _class3, _descriptor3, _descriptor4, _descriptor5, _dec6, _class4, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveTrait from "../../Decorators/primitiveTrait";
import ModelTraits from "../../ModelTraits";
export let BinStyleTraits = (_dec = primitiveTrait({
  name: "Value",
  description: "The maximum value of the bin for a given style.",
  type: "number",
  isNullable: true
}), _class = class BinStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "maxValue", _descriptor, this);
  }
  static isRemoval(style) {
    return style.maxValue === null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "maxValue", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let EnumStyleTraits = (_dec2 = primitiveTrait({
  name: "Value",
  description: "The enumerated value to map to a style.",
  type: "string",
  isNullable: true
}), _class2 = class EnumStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "value", _descriptor2, this);
  }
  static isRemoval(style) {
    return style.value === null;
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export let TableStyleMapTraits = (_dec3 = primitiveTrait({
  name: "Enabled",
  description: "True to enable.",
  type: "boolean"
}), _dec4 = primitiveTrait({
  name: "Style map type",
  description: 'The type of style map. Valid values are "continuous", "enum", "bin", "constant"',
  type: "string"
}), _dec5 = primitiveTrait({
  name: "Column",
  description: "The column to use for styling.",
  type: "string"
}), _class3 = class TableStyleMapTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "enabled", _descriptor3, this);
    _initializerDefineProperty(this, "mapType", _descriptor4, this);
    _initializerDefineProperty(this, "column", _descriptor5, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "enabled", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "mapType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "column", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _class3);
export let TableStyleMapSymbolTraits = (_dec6 = primitiveTrait({
  name: "Value",
  description: "The enumerated value to map to a color.",
  type: "string"
}), _class4 = class TableStyleMapSymbolTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "legendTitle", _descriptor6, this);
  }
}, _descriptor6 = _applyDecoratedDescriptor(_class4.prototype, "legendTitle", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class4);